import { FunctionComponent } from "react";
import { XIcon } from "@heroicons/react/solid";
import moment from "moment";

interface DateRangeFilterProps {
  fromLabel?: string;
  toLabel?: string;
  fromDate?: string;
  toDate?: string;
  onFromChange: (value: string | undefined) => void;
  onToChange: (value: string | undefined) => void;
  /** Show removable chips for the applied dates (Orders pattern). */
  showChips?: boolean;
  /** Hide the inner From/To labels so the field aligns with single controls. */
  compact?: boolean;
}

/**
 * From/To native date inputs with optional applied-date chips. Mirrors the
 * Orders module's "Created From / Created To" filter block.
 */
const DateRangeFilter: FunctionComponent<DateRangeFilterProps> = ({
  fromLabel = "From",
  toLabel = "To",
  fromDate,
  toDate,
  onFromChange,
  onToChange,
  showChips = true,
  compact = false,
}) => {
  return (
    <div>
      <div className="flex gap-2 items-end">
        <div className="flex-1">
          {!compact && (
            <label className="text-xs text-gray-500 mb-1 block">
              {fromLabel}
            </label>
          )}
          <input
            title={fromLabel}
            aria-label={fromLabel}
            className="border rounded text-sm w-full h-8 px-1"
            type="date"
            value={fromDate ?? ""}
            onChange={(e) => onFromChange(e.target.value || undefined)}
          />
        </div>
        <div className="flex-1">
          {!compact && (
            <label className="text-xs text-gray-500 mb-1 block">
              {toLabel}
            </label>
          )}
          <input
            title={toLabel}
            aria-label={toLabel}
            className="border rounded text-sm w-full h-8 px-1"
            type="date"
            value={toDate ?? ""}
            onChange={(e) => onToChange(e.target.value || undefined)}
          />
        </div>
      </div>

      {showChips && (fromDate || toDate) && (
        <div className="flex mt-1 items-center gap-1 flex-wrap">
          {fromDate && (
            <div className="text-xs font-semibold bg-gray-200 rounded-3xl pl-2 py-1 flex items-center">
              {moment(fromDate, "YYYY-MM-DD").format("DD-MM-YYYY")}
              <XIcon
                className="h-4 w-4 hover:bg-gray-400 hover:text-white p-1 rounded-full mx-1 cursor-pointer"
                onClick={() => onFromChange(undefined)}
              />
            </div>
          )}
          {toDate && (
            <div className="text-xs font-semibold bg-gray-200 rounded-3xl pl-2 py-1 flex items-center">
              {moment(toDate, "YYYY-MM-DD").format("DD-MM-YYYY")}
              <XIcon
                className="h-4 w-4 hover:bg-gray-400 hover:text-white p-1 rounded-full mx-1 cursor-pointer"
                onClick={() => onToChange(undefined)}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;
